import React, { useState, useEffect, useRef } from 'react';
import CommonModal from '../../components/commonComponent/CommonModal';
import CommonTable from '../../components/commonComponent/CommanTable';
import UserFilters from '../../components/commonComponent/CommanFilters';
import { validateForm } from '../../utils/formUtils';
import { FaPencilAlt, FaEye } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../../utils/axiosInstance';
import { toastSuccess, toastError, confirmDelete } from '../../utils/alertHelper';
import { hasPermission } from '../../utils/permissionHelper';

const allFields = [
  { key: 'srNo', label: 'Sr.No.' },
  { key: 'name', label: 'Name' },
  { key: 'companyName', label: 'Company name' },
  { key: 'planName', label: 'Current Plan Name' },
  { key: 'status', label: 'Company Status' },
  { key: 'endDate', label: 'End Date' },
  { key: 'mobileNumber', label: 'Mobile Number' },
  { key: 'email', label: 'Email' },
  { key: 'gstNumber', label: 'GST Number' },
  { key: 'city', label: 'City' },
  { key: 'state', label: 'State' },
  { key: 'country', label: 'Country' },
  { key: 'status', label: 'Status' },
];

const solarPartnerFields = [
  { type: "heading", label: "Basic Information" },
  { name: "firstName", label: "First Name", type: "text", placeholder: "First Name" },
  { name: "lastName", label: "Last Name", type: "text", placeholder: "Last Name" },
  { name: "companyName", label: "Company Name", type: "text", placeholder: "Company Name" },
  { name: "city", label: "City", type: "select", options: [], placeholder: "Select City" },
  { name: "state", label: "State", type: "select", options: [], placeholder: "Select State" },
  { name: "country", label: "Country", type: "select", options: [], placeholder: "Select Country" },
  { type: "heading", label: "Contact Information" },
  { name: "mobileNumber", label: "Mobile Number", type: "text", placeholder: "Mobile Number" },
  { name: "email", label: "Email", type: "email", placeholder: "Email" },
  { type: "heading", label: "Business Information" },
  { name: "gstNumber", label: "GST Number", type: "text", placeholder: "GST Number" },
  {
    name: "status", label: "Company Status", type: "select", options: [
      { value: "New", label: "New" },
      { value: "Active", label: "Active" },
      { value: "Inactive", label: "Inactive" },
      { value: "Suspended", label: "Suspended" },
    ], placeholder: "Select Company Status"
  },
  {
    name: "status", label: "Status", type: "select", options: [
      { value: "Active", label: "Active" },
      { value: "Inactive", label: "Inactive" },
    ], placeholder: "Select Status"
  },
];

const initialSolarPartnerValues = {
  firstName: "",
  lastName: "",
  companyName: "",
  city: "",
  state: "",
  country: "",
  mobileNumber: "",
  email: "",
  gstNumber: "",
  companyStatus: "",
  status: "Active",
  plan: "",
};

function SolarIndex() {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(initialSolarPartnerValues);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [partners, setPartners] = useState([]);
  const [filteredPartners, setFilteredPartners] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showFilters, setShowFilters] = useState(false);

  const defaultLimit = process.env.REACT_APP_PAGE_LIMIT ? parseInt(process.env.REACT_APP_PAGE_LIMIT, 10) : 10;
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(defaultLimit);
  const [totalPartners, setTotalPartners] = useState(0);

  const [showColumnDropdown, setShowColumnDropdown] = useState(false);
  const columnDropdownRef = useRef(null);

  const [user, setUser] = useState(null);
  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("user");
      if (storedUser) setUser(JSON.parse(storedUser));
    } catch {}
  }, []);

  // Permissions
  const canListSolar = hasPermission(user, 'Solar Partner', 'List');
  const canViewSolar = hasPermission(user, 'Solar Partner', 'View');
  const canCreateSolar = hasPermission(user, 'Solar Partner', 'Create');
  const canEditSolar = hasPermission(user, 'Solar Partner', 'Edit');
  const canDeleteSolar = hasPermission(user, 'Solar Partner', 'Delete');
  const canExportSolar = hasPermission(user, 'Solar Partner', 'Export');

  const forcedFields = ['srNo'];
  const getInitialVisibleFields = () => {
    const stored = localStorage.getItem('solar_visible_columns');
    return stored ? JSON.parse(stored) : allFields.map(f => f.key);
  };
  const [visibleFields, setVisibleFields] = useState(getInitialVisibleFields);

  useEffect(() => {
    localStorage.setItem('solar_visible_columns', JSON.stringify(visibleFields));
  }, [visibleFields]);

  useEffect(() => {
    if (!showColumnDropdown) return;
    function handleClickOutside(event) {
      if (columnDropdownRef.current && !columnDropdownRef.current.contains(event.target)) {
        setShowColumnDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showColumnDropdown]);

  const [filters, setFilters] = useState({
    companyStatus: '',
    status: '',
    duration: '',
    cityId: '',
    stateId: '',
    countryId: '',
    startDate: '',
    endDate: '',
  });

  const [dropdowns, setDropdowns] = useState({
     companyStatuses: [
      { value: 'Licensed Expired', label: 'Licence Expired' },
      { value: 'Trial Expired', label: 'Trial Expired' },
      { value: 'New', label: 'New' },
      { value: 'Active', label: 'Active' },
      { value: 'Inactive', label: 'Inactive' },
      { value: 'Suspended', label: 'Suspended' },
    ],
    statuses: [
      { value: 'Active', label: 'Active' },
      { value: 'Inactive', label: 'Inactive' },
      { value: 'Suspended', label: 'Suspended' },
    ],
    durations: [
      { value: 'last_week', label: 'Registered In Last 1 Week' },
      { value: 'last_month', label: 'Registered In Last 1 Month' },
      { value: 'all', label: 'All Time' },
    ],
    countries: [],
    states: [],
    cities: [],
    plans: [],
  });

  // Fetch countries
  const fetchCountries = async () => {
    try {
      const res = await axios.get('/admin/api/country');
      const raw = (res.data.countries || res.data.data || []);
      const countries = raw.filter(Boolean).map(c => ({ value: c._id, label: c?.name || '' }));
      setDropdowns(prev => ({ ...prev, countries }));

      const indiaCountry = countries.find(c => c && c.label && c.label.toLowerCase() === 'india');
      const storedCountry = localStorage.getItem("defaultCountry");
      const defaultCountry = indiaCountry?.value || storedCountry || countries[0]?.value || "";

      if (defaultCountry) {
        await fetchStates(defaultCountry);
      }

      return defaultCountry;
    } catch (err) {
      toastError("Failed to fetch countries.");
      return "";
    }
  };

  // Fetch states based on country
  const fetchStates = async (countryId) => {
    try {
      let url = '/admin/api/state';
      if (countryId) url += `?countryId=${countryId}`;
      const res = await axios.get(url);
      const raw = (res.data.states || res.data.data || []);
      const states = raw.filter(Boolean).map(s => ({ value: s._id, label: s?.name || '' }));
      setDropdowns(prev => ({ ...prev, states }));

      const gujaratState = states.find(s => s && s.label && s.label.toLowerCase() === 'gujarat');
      const storedState = localStorage.getItem("defaultState");
      const defaultState = gujaratState?.value || storedState || states[0]?.value || "";
      if (defaultState) {
        await fetchCities(defaultState);
      }
      return defaultState;
    } catch (err) {
      toastError("Failed to fetch states.");
      return "";
    }
  };

  // Fetch cities based on state
  const fetchCities = async (stateId) => {
    try {
      let url = '/admin/api/city';
      if (stateId) url += `?stateId=${stateId}`;
      const res = await axios.get(url);
      const raw = (res.data.cities || res.data.data || []);
      const cities = raw.filter(Boolean).map(c => ({ value: c._id, label: c?.name || '' }));
      setDropdowns(prev => ({ ...prev, cities }));

      const ahmedabadCity = cities.find(c => c && c.label && c.label.toLowerCase() === 'ahmedabad');
      const storedCity = localStorage.getItem("defaultCity");
      const defaultCity = ahmedabadCity?.value || storedCity || cities[0]?.value || "";

      return defaultCity;
    } catch (err) {
      toastError("Failed to fetch cities.");
      return "";
    }
  };

  useEffect(() => {
    async function fetchDropdowns() {
      try {
        const planRes = await axios.get('/api/plan');
        const plans = (planRes.data.plans || planRes.data.data || []).map(p => ({ value: p._id, label: p.name }));
        setDropdowns(prev => ({ ...prev, plans }));
        await fetchCountries();
      } catch (err) {
        toastError("Failed to fetch dropdowns.");
      }
    }

    async function fetchPartners(pageArg = page, limitArg = limit) {
      if (!canListSolar && !canViewSolar) {
        setPartners([]);
        setFilteredPartners([]);
        return;
      }
      try {
        const params = {
          userType: 'Company',
          role: 'CompanyAdmin',
          page: pageArg,
          limit: limitArg,
        };
        const res = await axios.get('/api/user', { params });
        const users = res.data && (res.data.users || res.data.data || []);
        if (Array.isArray(users)) {
          setPartners(users);
          setFilteredPartners(users);
        } else {
          setPartners([]);
          setFilteredPartners([]);
        }

        const total = res.data && (
          res.data.total || res.data.count || res.data.totalItems || res.data.totalCount ||
          res.data.meta?.total || res.data.pagination?.total || (Array.isArray(users) ? users.length : 0)
        );
        setTotalPartners(Number(total) || 0);
      } catch (err) {
        toastError("Failed to fetch users.");
      }
    }

    fetchDropdowns();
    fetchPartners(page, limit);
  }, [canListSolar, canViewSolar, page, limit]);

  useEffect(() => {
    if (modalData.country && showModal) {
      setDropdowns(prev => ({ ...prev, cities: [] }));
      fetchStates(modalData.country).then(defaultState => {
        setModalData(prev => ({ ...prev, state: "", city: "" }));
      });
    }
  }, [modalData.country, showModal]);

  useEffect(() => {
    if (modalData.state && showModal) {
      fetchCities(modalData.state).then(defaultCity => {
        setModalData(prev => ({ ...prev, city: "" }));
      });
    }
  }, [modalData.state, showModal]);

  const dynamicSolarPartnerFields = solarPartnerFields.map(field => {
    if (field.name === "city") {
      return { ...field, options: dropdowns.cities };
    }
    if (field.name === "state") {
      return { ...field, options: dropdowns.states };
    }
    if (field.name === "country") {
      return { ...field, options: dropdowns.countries };
    }
    if (field.name === "plan") {
      return { ...field, options: dropdowns.plans };
    }
    return field;
  });

  useEffect(() => {
    // Reset to first page when user changes search or filter
    setPage(1);
    applyFilters(partners);
  }, [searchTerm, filters]);

  useEffect(() => {
    // When server data changes, apply filters but do not reset page
    applyFilters(partners);
  }, [partners]);

  const tableColumns = allFields
    .filter(field => forcedFields.includes(field.key) || visibleFields.includes(field.key))
    .map(field => ({ key: field.key, label: field.label }))
    .concat([{ key: 'actions', label: 'Action' }]);

  const handleDelete = async (partner) => {
    if (!canDeleteSolar) {
      toastError("You do not have permission to delete solar partners.");
      return;
    }
    try {
      const res = await confirmDelete("Are you sure you want to delete this partner?");
      if (!res.isConfirmed) return;
    } catch (err) { return; }
    try {
      const id = partner.id || partner._id;
      const response = await axios.delete(`/api/user/delete/${id}`);
      if (response.data && response.data.Status === 1) {
        setPartners(prev => prev.filter(p => (p.id || p._id) !== id));
        setFilteredPartners(prev => prev.filter(p => (p.id || p._id) !== id));
        toastSuccess("User deleted successfully!");
      } else {
        setErrors({ api: response.data.Message || "Failed to delete user" });
        toastError(response.data.Message || "Failed to delete user");
      }
    } catch (error) {
      setErrors({ api: error.response?.data?.Message || "Failed to delete user" });
      toastError(error.response?.data?.Message || "Failed to delete user");
    }
  };

  const tableData = filteredPartners.map((partner, idx) => ({
    ...partner,
    srNo: (page - 1) * limit + idx + 1,
    name: `${partner.firstName || ''} ${partner.lastName || ''}`.trim(),
    clientId: partner.memberId || "",
    companyName: partner.business?.name || "",
    gstNumber: partner.business?.gstNumber || "",
    planName: (typeof partner.plan === 'object' && partner.plan !== null)
      ? (partner.plan.plan?.name || partner.plan.name || '')
      : (partner.plan || ''),
    endDate: partner.plan?.endDate ? new Date(partner.plan.endDate).toLocaleDateString() : '',
    status: partner.business?.status || "",
    mobileNumber: partner.mobileNumber || "",
    email: partner.email || "",
    city: partner.city && typeof partner.city === 'object' ? partner.city.name : partner.city,
    state: partner.state && typeof partner.state === 'object' ? partner.state.name : partner.state,
    country: partner.country && typeof partner.country === 'object' ? partner.country.name : partner.country,
    status: partner.status && typeof partner.status === 'object'
      ? (partner.status.name || '')
      : (
        <span
          className={`badge px-3 py-2 rounded-pill`}
          style={{
            backgroundColor: partner.status === 'Active' ? '#28a745' : '#6c757d',
            color: '#fff',
            fontWeight: 500,
            fontSize: '0.95rem',
            borderRadius: '20px',
            minWidth: 75,
            display: 'inline-block',
            textAlign: 'center'
          }}
        >
          {partner.status}
        </span>
      ),
    actions: (
      <div>
        {canViewSolar && (
            <Link
              to={`/dashboard/solar/view/${partner.id || partner._id}`}
              className="btn btn-sm py-0 px-1 fs-6 lh-sm shadow-none border-0 text-primary-custom"
              title="View"
              style={{ textDecoration: "none" }}
            >
              <FaEye size={14} />
            </Link>
          )}
          {canEditSolar && (
            <button
              className="btn btn-sm me-1 py-0 px-1 fs-6 lh-sm shadow-none border-0 text-primary-custom"
              title="Edit"
              onClick={() => handleEdit(partner)}
            >
              <FaPencilAlt size={14} />
            </button>
          )} 
      </div>
    ),
  }));

  const handleAdd = async () => {
    if (!canCreateSolar) {
      toastError("You do not have permission to add new solar partners.");
      return;
    }
    const indiaCountry = dropdowns.countries.find(c => c && c.label && c.label.toLowerCase() === 'india');
    const defaultCountry = indiaCountry?.value || dropdowns.countries[0]?.value || "";

    setModalData({
      ...initialSolarPartnerValues,
      status: "Active",
      companyStatus: "",
      country: defaultCountry,
      state: "",
      city: "",
      business: {
        name: "",
        gstNumber: "",
        status: ""
      },
    });

    setDropdowns(prev => ({
      ...prev,
      states: [],
      cities: []
    }));

    setErrors({});
    setShowModal(true);
  };

  const handleEdit = async (partner) => {
    if (!canEditSolar) {
      toastError("You do not have permission to edit solar partners.");
      return;
    }
    const countryId = partner.country && typeof partner.country === 'object' ? partner.country._id : partner.country;
    const stateId = partner.state && typeof partner.state === 'object' ? partner.state._id : partner.state;
    const cityId = partner.city && typeof partner.city === 'object' ? partner.city._id : partner.city;

    if (countryId) {
      await fetchStates(countryId);
    }
    if (stateId) {
      await fetchCities(stateId);
    }

    setModalData({
      ...partner,
      id: partner.id || partner._id,
      companyName: partner.business?.name || "",
      gstNumber: partner.business?.gstNumber || "",
      status: partner.business?.status || "",
      status: partner.status || "Active",
      country: countryId || "",
      state: stateId || "",
      city: cityId || "",
    });
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async () => {
    const validationRules = {
      companyName: { required: true },
      firstName: { required: true },
      lastName: { required: true },
      city: { required: true },
      state: { required: true },
      country: { required: true },
      mobileNumber: { required: true },
      email: { required: true, email: true },
      status: { required: true },
    };

    const payload = {
      companyName: modalData.companyName,
      firstName: modalData.firstName,
      lastName: modalData.lastName,
      city: modalData.city,
      state: modalData.state,
      country: modalData.country,
      mobileNumber: modalData.mobileNumber,
      email: modalData.email,
      password: modalData.password || "",
      userType: "Company",
      business: {
        name: modalData.companyName,
        gstNumber: modalData.gstNumber,
        status: modalData.status,
      },
      status: modalData.status,
    };

    setIsSubmitting(true);
    try {
      let response;
      if (modalData.id) {
        if (!modalData.id || typeof modalData.id !== 'string' || modalData.id.length < 10) {
          setErrors({ api: "Invalid user ID. Cannot update user." });
          toastError("Invalid user ID. Cannot update user.");
          setIsSubmitting(false);
          return;
        }
        response = await axios.put(`/api/user/${modalData.id}`, payload);
        if (response.data && response.data.Status === 1 && response.data.user) {
          const updatedUser = response.data.user;
          setPartners(prev =>
            prev.map(p =>
              (p.id === updatedUser._id || p._id === updatedUser._id)
                ? { ...p, ...updatedUser }
                : p
            )
          );
          setFilteredPartners(prev =>
            prev.map(p =>
              (p.id === updatedUser._id || p._id === updatedUser._id)
                ? { ...p, ...updatedUser }
                : p
            )
          );
          setShowModal(false);
          setModalData(initialSolarPartnerValues);
          setErrors({});
          toastSuccess("User updated successfully!");
        } else {
          setErrors({ api: response.data.Message || "Failed to update user" });
          toastError(response.data.Message || "Failed to update user");
        }
      } else {
        response = await axios.post('/api/user/create', payload);
        if (response.data && response.data.Status === 1 && response.data.user) {
          const user = response.data.user;
          const newPartner = {
            id: user._id,
            firstName: user.firstName,
            lastName: user.lastName,
            city: user.city,
            state: user.state,
            country: user.country,
            mobileNumber: user.mobileNumber,
            email: user.email,
            status: user.business?.status || "",
            createdAt: user.createdAt,
            business: user.business,
          };
          setPartners(prev => [...prev, newPartner]);
          applyFilters([...partners, newPartner]);
          setShowModal(false);
          setModalData(initialSolarPartnerValues);
          setErrors({});
          toastSuccess("User created successfully!");
        } else {
          setErrors({ api: response.data.Message || "Failed to create user" });
          toastError(response.data.Message || "Failed to create user");
        }
      }
    } catch (error) {
      setErrors({ api: error.response?.data?.Message || "Failed to save user" });
      toastError(error.response?.data?.Message || "Failed to save user");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    applyFilters(partners, newFilters);
  };

  const handleClearFilters = () => {
    setFilters({
      companyStatus: '',
      status: '',
      duration: '',
      cityId: '',
      stateId: '',
      countryId: '',
      startDate: '',
      endDate: '',
    });
    setFilteredPartners(partners);
  };

  const applyFilters = (dataToFilter = partners, filtersToApply = filters) => {
    let filtered = [...dataToFilter];
    if (filtersToApply.companyStatus) {
      filtered = filtered.filter(partner =>
        partner.companyStatus === filtersToApply.companyStatus
      );
    }
    if (filtersToApply.status) {
      filtered = filtered.filter(partner =>
        partner.status === filtersToApply.status
      );
    }
    if (filtersToApply.duration) {
      // Add duration logic if needed
    }
    if (filtersToApply.stateId) {
      const selectedState = dropdowns.states.find(s => s.value === filtersToApply.stateId);
      if (selectedState) {
        filtered = filtered.filter(partner => {
          const partnerState = typeof partner.state === 'object' ? partner.state?.name : partner.state;
          return (partnerState || '').toLowerCase() === selectedState.label.toLowerCase();
        });
      }
    }
    if (filtersToApply.cityId) {
      const selectedCity = dropdowns.cities.find(c => c.value === filtersToApply.cityId);
      if (selectedCity) {
        filtered = filtered.filter(partner => {
          const partnerCity = typeof partner.city === 'object' ? partner.city?.name : partner.city;
          return (partnerCity || '').toLowerCase() === selectedCity.label.toLowerCase();
        });
      }
    }
    if (filtersToApply.countryId) {
      const selectedCountry = dropdowns.countries.find(c => c.value === filtersToApply.countryId);
      if (selectedCountry) {
        filtered = filtered.filter(partner => {
          const partnerCountry = typeof partner.country === 'object' ? partner.country?.name : partner.country;
          return (partnerCountry || '').toLowerCase() === selectedCountry.label.toLowerCase();
        });
      }
    }
    if (filtersToApply.startDate) {
      filtered = filtered.filter(partner =>
        partner.createdAt >= filtersToApply.startDate
      );
    }
    if (filtersToApply.endDate) {
      filtered = filtered.filter(partner =>
        partner.createdAt <= filtersToApply.endDate
      );
    }
    if (searchTerm) {
      filtered = filtered.filter(partner =>
        (partner.firstName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (partner.lastName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (partner.companyName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (partner.email || '').toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    setFilteredPartners(filtered);
  };

  // --------------- Export Functionality ---------------
  const handleExport = async () => {
    if (!canExportSolar) {
      toastError("You do not have permission to export solar partners.");
      return;
    }
    try {
      const exportParams = {};
      Object.entries(filters).forEach(([key, value]) => {
        if (value) exportParams[key] = value;
      });

      const res = await axios.get('/api/user/export-excel', {
        params: exportParams,
        responseType: 'blob'
      });
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'solar-partners.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toastSuccess('Export successful!');
    } catch (err) {
      toastError('Failed to export data.');
    }
  };
  // ----------------------------------------------------

  return (
    <>
      <div className="container-fluid mt-4">
        <div className="d-flex justify-content-between align-items-center mb-4 mt-4">
         <h2 className="h2 mb-0">Solar Partners</h2>
          <div className="d-flex gap-2 align-items-center">
            <button
              className="btn btn-light"
              onClick={() => setShowFilters(!showFilters)}
            >
              <i className="fas fa-filter me-1"></i> Filter
            </button>
            {canExportSolar && (
              <button
                className="btn btn-light"
                onClick={handleExport}
              >
                <i className="fas fa-download me-1"></i> Export
              </button>
            )}
            {canCreateSolar && (
              <button
                className="btn btn-primary"
                onClick={handleAdd}
              >
                <i className="fas fa-plus me-1"></i> Add New Member
              </button>
            )}
            <div style={{ position: 'relative' }} ref={columnDropdownRef}>
              <button
                className="btn btn-sm btn-light"
                onClick={() => setShowColumnDropdown(show => !show)}
              >
                <i className="fas fa-eye me-1"></i>
              </button>
              {showColumnDropdown && (
                <div
                  className="dropdown-menu show p-3"
                  style={{
                    maxHeight: 250,
                    overflowY: 'auto',
                    right: 0,
                    left: 'auto',
                    position: 'absolute',
                    zIndex: 1050,
                    width: 'max-content',
                    minWidth: 220,
                  }}
                >
                  {allFields.map(col => (
                    <div key={col.key} className="form-check mb-1">
                      <input
                        type="checkbox"
                        id={`col-filter-${col.key}`}
                        className="form-check-input"
                        checked={visibleFields.includes(col.key) || forcedFields.includes(col.key)}
                        disabled={forcedFields.includes(col.key)}
                        onChange={e => {
                          if (e.target.checked) {
                            setVisibleFields(prev => {
                              const allKeys = allFields.map(c => c.key);
                              const newCols = [...prev, col.key];
                              const uniqueCols = Array.from(new Set(newCols));
                              uniqueCols.sort((a, b) => allKeys.indexOf(a) - allKeys.indexOf(b));
                              return uniqueCols;
                            });
                          } else {
                            setVisibleFields(prev => prev.filter(k => k !== col.key));
                          }
                        }}
                      />
                      <label htmlFor={`col-filter-${col.key}`} className="form-check-label">
                        {col.label}
                      </label>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        {showFilters && (
          <div className="mb-4">
            <UserFilters
              filters={filters}
              dropdowns={dropdowns}
              onFilterChange={handleFilterChange}
              onClearFilters={handleClearFilters}
              fields={[
                'companyStatus',
                'status',
                'duration',
                'city',
                'state',
                'country',
                'dateRange'
              ]}
            />
          </div>
        )}
        <div className="row mb-4">
          <div className="col-md-6"></div>
          <div className="col-md-6 d-flex justify-content-end">
            <div className="input-group" style={{ maxWidth: 280, borderRadius: '6px', overflow: 'hidden' }}>
              <span className="input-group-text bg-white border-end-0" style={{ borderRadius: '6px 0 0 6px' }}>
                <i className="fas fa-search text-muted"></i>
              </span>
              <input
                type="text"
                className="form-control border-start-0"
                placeholder="Type to search..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                style={{ boxShadow: 'none', borderRadius: '0 6px 6px 0' }}
              />
            </div>
          </div>
        </div>
        <CommonTable
          columns={tableColumns}
          data={tableData}
          itemsPerPageOptions={[10, 15, 25, 50]}
          defaultItemsPerPage={10}
          page={page}
          onPageChange={setPage}
          itemsPerPage={limit}
          onItemsPerPageChange={setLimit}
          totalItems={totalPartners}
        />
        <CommonModal
          visible={showModal}
          title={
            <span style={{ color: "#3F3F46", fontFamily: "Poppins" }}>
              {modalData && modalData.id ? "Edit Solar Partner" : "New Solar Partner"}
            </span>
          }
          fields={dynamicSolarPartnerFields}
          values={modalData}
          onChange={setModalData}
          onCancel={() => {
            setShowModal(false);
            setModalData(initialSolarPartnerValues);
            setErrors({});
          }}
          onSubmit={handleSubmit}
          submitLabel={isSubmitting ? (modalData && modalData.id ? "Updating..." : "Saving...") : (modalData && modalData.id ? "Update" : "Save")}
          cancelLabel="Cancel"
          requiredFields={[
            "companyName",
            "firstName",
            "lastName",
            "city",
            "state",
            "country",
            "mobileNumber",
            "email",
            "status",
          ]}
          errors={errors}
          disabled={isSubmitting}
        />
      </div>
    </>
  );
}

export default SolarIndex;